class Header {
	static block_name = "b-techart-header";

	constructor($elem) {
		this.$elem = $elem;
	}

	onInit() {
		const it = this;
		const $burger = it.$elem.find(
			`.${Header.block_name}__burger`
		);

		const $btn = it.$elem.find(
			`.${Header.block_name}__btn`
		);

		$burger.click(function() {
			it.$elem.toggleClass('active')
			$(this).toggleClass('active')
			if (this.classList.contains('active')) {
				dataLayer.push({
					event: "mobile_menu",
					menu_action: "open"
				});
			} else {
				dataLayer.push({
					event: "mobile_menu",
					menu_action: "close"
				});
			}
		});

		$btn.click(function() {
			it.$elem.removeClass('active')
			$burger.removeClass('active')
		});

	}
}
export default Header;
